import {schema} from 'normalizr';

/** @module facilities/schemas */

/**
 * Represents a parking spot entity.
 */
export const parkingSpotEntity = new schema.Entity('parkingSpots');

/**
 * Represents a canonical facility entity.
 *
 * @example
 * {
 *    entities: {
 *        canonicalFacilities: {
 *          1: {
 *           id: 1,
 *            parkingSpots: [1, 2, 3],
 *           // canonical facility data
 *            },
 *           },
 *        parkingSpots: {
 *          1: {
 *              id: 1,
 *              canonicalFacilityId: 1,
 *              // parking spot data
 *              },
 *         },
 *   }
 *
 */
export const canonicalFacilityEntity = new schema.Entity(
    'canonicalFacilities',
    {
        parkingSpots: [parkingSpotEntity],
    }
);
